<template>
    <el-dialog :title="warehouseEditId ? '编辑仓库' : '新建仓库'" :visible.sync="warehouseTplDialog" width="520px" :before-close="handleDialogClose" :close-on-click-modal="false" class="custom-form-dialog">
        <el-form ref="formData" :rules="formRules" :model="formData" label-position="top" v-loading="loading">
            <el-form-item label="仓库名称" prop="name">
                <el-input size="small" v-model="formData.name" placeholder="请输入仓库名称"  maxlength="30"  show-word-limit></el-input>
            </el-form-item>

            <el-form-item label="仓库地址" prop="addr">
                <el-input size="small" v-model="formData.addr" type="textarea" :rows="4" placeholder="请输入仓库地址"  maxlength="200"  show-word-limit></el-input>
            </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose">取消</el-button>
            <el-button type="primary" :disabled="BtnDisabled" @click.stop="handleDialogConfirm" >提交</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {  stockAdd, stockDetail,  stockEdit } from "@/api/index.js"
export default {
    name: "warehouse_tpl",
    props: {
        warehouseTplDialog: {
            type: Boolean,
            default: false
        },
        warehouseEditId: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            loading:false,
            BtnDisabled:false,
            formData: {
                name: "",
                addr:""
            },
            formRules: {
                name: [
                    {required: true, message: "请输入仓库名称"}
                ]
            },
        }
    },
    created() {
        if(this.warehouseEditId){
            this.getWarehouseDetail()
        }
    },
    methods: {
        getWarehouseDetail(){
            this.loading = true
            stockDetail({id:this.warehouseEditId}).then(res=> {
                if(res.code === 200) {
                    let { name, addr} = res.data
                    this.formData = {
                        name,
                        addr
                    }
                }
                this.loading = false
            })
        },

        handleDialogClose() {
            this.$emit("update:warehouseTplDialog", false)
        },
        handleDialogConfirm() {
            this.$refs.formData.validate(valid => {
                if (valid) {
                    this.BtnDisabled = true
                    let postData = {
                        name: this.formData.name,
                        addr: this.formData.addr
                    }
                    if(this.warehouseEditId){
                        postData.id = this.warehouseEditId
                        stockEdit(postData).then(res=> {
                            if(res.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message: '编辑成功',
                                    duration: 1500,
                                    onClose: () => {
                                        this.handleDialogClose()
                                        this.$emit('success')
                                        this.BtnDisabled = false
                                    }
                                })
                            }else{
                                this.BtnDisabled = false
                            }
                        })
                    }else{
                        stockAdd(postData).then(res=> {
                            if(res.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message: '新建成功',
                                    duration: 1500,
                                    onClose: () => {
                                        this.handleDialogClose()
                                        this.$emit('success')
                                        this.BtnDisabled = false
                                    }
                                })
                            }else{
                                this.BtnDisabled = false
                            }
                        })
                    }


                }
            })
        },

    }
}
</script>
